<template>
  <span v-if="instance.publicIp && domainsAlert.length > 0">
    <el-alert
      v-for="domain in domainsAlert"
      :key="domain.name"
      type="warning"
      class="instance-domain"
      :closable="false"
      show-icon
    >
      <span slot="title">
        The domain name <router-link :to="domainLink(domain)">{{ domain.name }}</router-link> does not yet point to the ip {{ instance.publicIp }}
      </span>
      <el-button
        type="warning"
        size="mini"
        icon="mdi mdi-eye-off"
        @click="ignore(domain)"
      >
        Ignore alert
      </el-button>
    </el-alert>
  </span>
</template>

<script>
export default {
  props: {
    instance: {
      type: Object,
      default: () => ({})
    },
    instanceApplications: {
      type: Array,
      default: () => []
    },
    domains: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    applicationsIps () {
      return this.instanceApplications.filter((a) => a.publicIp).map((a) => a.publicIp)
    },
    domainsAlert () {
      let applicationConnected
      for (const ip in this.applicationsIps) {
        this.domains.forEach((d) => {
          if (d.ips.indexOf(ip)) {
            applicationConnected = true
          }
        })
      }
      return this.domains.filter((d) => d.resolved && !this.$cookies.get('ignore.' + d.id) &&
        d.ips.indexOf(this.instance.publicIp) === -1 && !applicationConnected &&
        d.proxy !== this.instance.publicIp)
    }
  },
  methods: {
    domainLink (domain) {
      if (domain.applications.length > 0) {
        return '/instances/' + this.instance.id + '/' + domain.applications[0].id + '/domain'
      }
    },
    ignore (domain) {
      this.$cookies.set('ignore.' + domain.id, domain.name)
      this.$nextTick(() => this.$set(domain, 'ignore', true))
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .el-alert {
    position: relative;
    font-size: 9px;
    width: 100%;
    margin: 0 !important;
    border-bottom: 1px solid $--border-color-base;

    .el-button--text {
      color: $--color-warning;
    }
  }
</style>

<style lang="scss">
  @import "../../theme";

  .instance-domain {
    .el-alert__description {
      position: absolute;
      right: 24px;
      top: 3px;
    }
    .el-alert__title {
      font-weight: 500;
    }
    &.el-alert--danger a {
      color: $--color-danger;
    }
    &.el-alert--warning a {
      color: $--color-warning;
    }
  }
</style>
